import { WebGPUBlurrer } from './webgpu.js';
import { CanvasBlurrer } from './canvas.js';

/**
 * Try to initialise the WebGPU blurrer; fall back to Canvas 2D if unavailable.
 * @returns {{ blurrer: WebGPUBlurrer|CanvasBlurrer, backend: 'webgpu'|'canvas' }}
 */
export async function createBlurrer() {
  try {
    const blurrer = await WebGPUBlurrer.create();
    return { blurrer, backend: 'webgpu' };
  } catch (err) {
    console.warn('[blurrer] WebGPU unavailable, falling back to Canvas 2D:', err.message);
    return { blurrer: new CanvasBlurrer(), backend: 'canvas' };
  }
}
